import { render, staticRenderFns } from "./PortalProfileSettings.vue?vue&type=template&id=71ff7ecf&scoped=true&"
import script from "./PortalProfileSettings.vue?vue&type=script&lang=js&"
export * from "./PortalProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./PortalProfileSettings.vue?vue&type=style&index=0&id=71ff7ecf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff7ecf",
  null
  
)

export default component.exports